import React from "react";
import "./global.css";
import HomePage from './pages/HomePage';

export default function App() {
  return (
    <div className="App">
      <HomePage />
    </div>

  );
}
